(function (Drupal) {
  'use strict';
  Drupal.frontendSwiper.registerLane('view-themes-carousel');
})(Drupal);
